import { Label } from 'design-system/label'
import styled from 'styled-components'

export const PageTitle = styled(Label)`
  font-weight: 500;
  font-size: 1.75em;
`
